import { reverse, take } from "ramda";

const sortDataTuples2 = (a: any[], b: any[]): number =>
Number(a[2]) - Number(b[2]);

export const sortTuples = (tuples: any[][]) =>
reverse(tuples.slice().sort(sortDataTuples2));

export const top3 = take(3);